/**
 * Route for `appsflyer-network-postback-installs-in-app-events`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AppsflyerNetworkPostbackInstallsInAppEventsPage } from "../features/appsflyer-network-postback-installs-in-app-events/AppsflyerNetworkPostbackInstallsInAppEventsPage";

export const appsflyerNetworkPostbackInstallsInAppEventsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/appsflyer-network-postback-installs-in-app-events",
	component: AppsflyerNetworkPostbackInstallsInAppEventsPage,
});

export default appsflyerNetworkPostbackInstallsInAppEventsRoute;
